import { Helmet } from 'react-helmet';
import style from './BlogPageDe.module.css';
import { NavLink } from 'react-router-dom';
import articlesDe from './articlesDe';

const BlogPageDe = () => {
  const formatTitleForUrl = title =>
    title.trim().toLowerCase().replace(/\s+/g, '_');

  return (
    <>
      <Helmet>
        <title>Blog – Artemida Studio (DE)</title>
        <meta
          name="description"
          content="Lesen Sie spannende Blogartikel von Artemida Studio über Webentwicklung, Design, Branding und digitale Strategien."
        />
        <meta
          name="keywords"
          content="blog, webentwicklung, branding, digitales design, kreative agentur, UI/UX, Artemida Studio"
        />
        <link rel="canonical" href="https://artemidastudio.com/de/blog" />

        {/* hreflang-Tags */}
        <link
          rel="alternate"
          hreflang="de"
          href="https://artemidastudio.com/de/blog"
        />
        <link
          rel="alternate"
          hreflang="en"
          href="https://artemidastudio.com/en/blog"
        />
        <link
          rel="alternate"
          hreflang="it"
          href="https://artemidastudio.com/it/blog"
        />
        <link
          rel="alternate"
          hreflang="x-default"
          href="https://artemidastudio.com/en/blog"
        />
      </Helmet>

      <div className={style.blogContainer}>
        <h1>Blogartikel</h1>
        <div className={style.wrapContainer}>
          {[...articlesDe].reverse().map(article => (
            <div className={style.gradientContainer} key={article._id}>
              <div className={style.projectItem}>
                <h1>{article.title}</h1>
                <div className={style.descriptionContainer}>
                  <p>{article.description}</p>
                </div>

                <div className={style.imgContainer}>
                  <img src={article.image} alt={article.title} loading="lazy" />
                </div>

                <NavLink
                  to={`/de/blog/article/${formatTitleForUrl(article.title)}/${
                    article._id
                  }`}
                >
                  <button className={style.website}>Mehr lesen...</button>
                </NavLink>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogPageDe;
